import React from "react";
import { Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";

export const IconBoxReusableComponent = ({
  classSection,
  onClick,
  src,
  title,
  iconText,
  imageStyle,
}) => {
  return (
    <React.Fragment>
      <div className={classSection} onClick={onClick}>
        <div className="text-center">
          {src ? (
            <img src={src} alt="icon" title={title} className={imageStyle} />
          ) : null}
          <p>{iconText}</p>
        </div>
      </div>
    </React.Fragment>
  );
};

export const IconBoxReusableSeatingComponent = ({
  classSection,
  bedgeClass,
  displayNotification,
  notificationCount,
  link,
  src,
  srcText,
  title,
  iconText,
  imageStyle,
  iconTextStyle,
  bottomLine,
  onClick
}) => {
  return (
    <React.Fragment>
      <NavLink
        to={link}
        onClick={onClick}
        className="seating-icon-box-section text-decoration-none"
      >
        <div>
          <div className={classSection}>
            {displayNotification === true ? (
              <span className={bedgeClass}>{notificationCount}</span>
            ) : null}
            {src ? (
              <img
                src={src}
                alt="icon"
                title={title}
                className={`img-fluid ${imageStyle}`}
              />
            ) : (
              srcText
            )}
          </div>
          <p className={iconTextStyle}>{iconText}</p>
        </div>
        {/* <div className={bottomLine}></div> */}
      </NavLink>
    </React.Fragment>
  );
};

export const IconBoxReusableSeatingComponentText = ({
  link,
  iconText,
  iconTextStyle,
  bottomLine,
}) => {
  return (
    <React.Fragment>
      <NavLink
        to={link}
        className="seating-icon-box-section text-decoration-none"
      >
        <div>
          <p className={iconTextStyle}>{iconText}</p>
        </div>
        <div className={bottomLine}></div>
      </NavLink>
    </React.Fragment>
  );
};

export const CountBoxReusableSeatingComponent = ({
  classSection,
  count,
  iconText,
  iconTextStyle,
}) => {
  return (
    <React.Fragment>
      {/* <div> */}
      <div className={`seating-dashboard-count-box ${classSection}`}>
        <h5 className="small-text-count-box f14-500">{count}</h5>
      </div>
      <p className={`f10-500 mt-1 ${iconTextStyle}`}>{iconText}</p>
      {/* </div> */}
    </React.Fragment>
  );
};

export const IconBoxEventButtonComponent = ({
  classSection,
  bedgeClass,
  displayNotification,
  notificationCount,
  onClick,
  src,
  srcText,
  title,
  iconText,
  imageStyle,
  iconTextStyle,
}) => {
  return (
    <React.Fragment>
      <Button
        type="button"
        onClick={onClick}
        className="seating-icon-box-section text-decoration-none bg-transparent border-0 pl-0"
      >
        <div>
          <div className={classSection}>
            {displayNotification === true ? (
              <span className={bedgeClass}>{notificationCount}</span>
            ) : null}
            {src ? (
              <img
                src={src}
                alt="icon"
                title={title}
                className={`img-fluid ${imageStyle}`}
              />
            ) : (
              srcText
            )}
          </div>
          <p className={iconTextStyle} style={{textAlign:"center"}}>{iconText}</p>
        </div>
      </Button>
    </React.Fragment>
  );
};
